// src/Chatmodules/chatService.js
import {db} from '../config/firebase';
import {collection, doc, setDoc, getDocs, deleteDoc} from "firebase/firestore";

// Función para guardar o actualizar un chat
export const saveOrUpdateChat = async (userId, chatId, messages, title) => {
    try {
        const chatDocRef = doc(db, 'users', userId, 'chats', chatId);

        // Asegurarse de que los mensajes no sean undefined
        const filteredMessages = messages.filter(message => message != null);

        const chatData = {
            messages: filteredMessages.length > 0 ? filteredMessages : [], // Asegura que no sea undefined
            title: title // Usar el título proporcionado
       };

        await setDoc(chatDocRef, chatData, {merge: true}); // Guardar mensajes y título
   } catch (error) {
        console.error("Error al guardar o actualizar el chat:", error);
   }
};

// Función para obtener todos los chats de un usuario
export const fetchAllChatsForUser = async (userId) => {
    const chatsCollection = collection(db, 'users', userId, 'chats');
    const chatDocs = await getDocs(chatsCollection);
    return chatDocs.docs.map(doc => ({id: doc.id, ...doc.data()}));
};  

// Función para eliminar un chat
export const eliminarChat = async (userId, chatId) => {
    try {
        const chatDocRef = doc(db, 'users', userId, 'chats', chatId);
        await deleteDoc(chatDocRef);
   } catch (error) {
        console.error('Error al eliminar el chat:', error);
   }
};